import { css } from '@emotion/react'

export const multiRiskAccordion = () => css`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`
